import { RANK_THRESHOLDS } from "../data/balance";

export class TimerSystem {
  remaining: number;
  readonly maximum: number;

  constructor(startTime: number) {
    this.remaining = startTime;
    this.maximum = startTime + 12;
  }

  update(deltaSeconds: number): void {
    this.remaining = Math.max(0, this.remaining - deltaSeconds);
  }

  add(seconds: number): void {
    this.remaining = Math.min(this.maximum, this.remaining + seconds);
  }

  get expired(): boolean { return this.remaining <= 0; }
  get overtime(): boolean { return this.remaining <= 5; }
}

export class ComboSystem {
  count = 0;
  multiplier = 1;
  private elapsed = Number.POSITIVE_INFINITY;

  constructor(private windowSeconds = 1.5) {}

  setWindow(seconds: number): void {
    this.windowSeconds = seconds;
  }

  update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
    if (this.elapsed > this.windowSeconds) this.break();
  }

  collect(): number {
    this.count = this.elapsed <= this.windowSeconds ? this.count + 1 : 1;
    this.elapsed = 0;
    this.multiplier = ComboSystem.forCount(this.count);
    return this.multiplier;
  }

  break(): void {
    this.count = 0;
    this.multiplier = 1;
  }

  static forCount(count: number): number {
    if (count >= 30) return 4;
    if (count >= 20) return 3;
    if (count >= 10) return 2;
    if (count >= 5) return 1.5;
    if (count >= 2) return 1.2;
    return 1;
  }
}

export const scoreFor = (base: number, multiplier: number): number =>
  Math.round(base * multiplier);

export const xpFor = (score: number, diamonds: number): number =>
  Math.floor(score / 100) + diamonds;

export const rankFor = (xp: number): number => {
  let rank = 1;
  RANK_THRESHOLDS.forEach((threshold, index) => {
    if (xp >= threshold) rank = index + 1;
  });
  return rank;
};
